<template>
  <span v-if="!flow || !flow.dispatched" class="grey--text">–</span>
  <v-chip v-else small :color="color" :outlined="outlined" :dark="!outlined" @click.stop="$emit('click')">
    <v-icon left x-small>{{ icon }}</v-icon>
    {{ label }}
    <span v-if="flow.changes_count" class="ml-1">· {{ $t("supplier_po.flow_changes", { n: flow.changes_count }) }}</span>
  </v-chip>
</template>

<script>
// Stanje slanja narudzbenice dobavljacu u listi: Poslano -> Otvoreno -> Odgovoreno (cekaju odluku).
export default {
  name: "WarehouseSupplierFlowCell",
  props: { item: { type: Object, required: true } },
  computed: {
    flow() {
      return this.item.supplier_flow;
    },
    state() {
      const f = this.flow;
      if (f.awaiting_decision) return "awaiting";
      if (f.responded_at) return "responded";
      if (!f.has_active_link) return "inactive";
      if (f.opened_at) return "opened";
      return "sent";
    },
    color() {
      return { awaiting: "warning", responded: "success", opened: "info", sent: undefined, inactive: "error" }[this.state];
    },
    outlined() {
      return ["sent"].includes(this.state);
    },
    icon() {
      return { awaiting: "mdi-message-reply-text-outline", responded: "mdi-check", opened: "mdi-eye-outline", sent: "mdi-send", inactive: "mdi-link-off" }[this.state];
    },
    label() {
      const f = this.flow;
      const d = (v) => (v ? new Date(v).toLocaleDateString("sr-Latn") : "");
      switch (this.state) {
        case "awaiting":
          return this.$t("supplier_po.flow_awaiting");
        case "responded":
          return this.$t("supplier_po.flow_responded", { date: d(f.responded_at) });
        case "opened":
          return this.$t("supplier_po.flow_opened", { date: d(f.opened_at) });
        case "inactive":
          return this.$t("supplier_po.flow_inactive");
        default:
          return this.$t("supplier_po.flow_sent", { date: d(f.last_sent_at) });
      }
    },
  },
};
</script>
